define(
    'BTM.OutOfStockBehaviour.OutOfStockBehaviour', [
        'Backbone', 'SC.Configuration', 'Item.KeyMapping', 'Item.Model', 'QuickAdd.View', 'Transaction.Line.Model', 'underscore', 'jQuery', 'Utils'
    ],
    function (
        Backbone, Configuration, ItemKeyMapping, ItemModel, QuickAddView, TransactionLineModel, _, jQuery, Utils
    ) {
        'use strict';

        return {
            mountToApp: function mountToApp(container) {
                var outOfStockBehaviourEnabled = Configuration.get('outOfStockBehaviour.enabled');
                if (!outOfStockBehaviourEnabled) {
                    return;
                }
                if (window) {
                    window.hasShowOutOfStockMessage = false;
                    window.hasShowOutOfStockMessage2 = false;
                }

                var layout = container.getComponent('Layout');

                function isInStock(item) {
                    var quantityavailable = item.get('quantityavailable');
                    if (item && item.attributes && item.attributes.matrixchilditems_detail && item.attributes.matrixchilditems_detail.length > 0) {
                        quantityavailable = 0;
                        for (var c of item.attributes.matrixchilditems_detail) {
                            quantityavailable += +c.quantityavailable;
                        }
                    }
                    var custitem_br_retail_out_of_stock_qty = item.get('custitem_br_retail_out_of_stock_qty');
                    var custitem_br_commer_out_of_stock_qty = item.get('custitem_br_commer_out_of_stock_qty');
                    var custitem_br_wholes_out_of_stock_qty = item.get('custitem_br_wholes_out_of_stock_qty');
                    var isInStock = item.get('isinstock');
                    if (isInStock === undefined || isInStock) {
                        try {
                            if (quantityavailable !== undefined || quantityavailable >= 0) {
                                if (custitem_br_retail_out_of_stock_qty !== undefined && custitem_br_retail_out_of_stock_qty !== null && _.isNumber(custitem_br_retail_out_of_stock_qty)) {
                                    isInStock = quantityavailable > custitem_br_retail_out_of_stock_qty;
                                } else if (custitem_br_commer_out_of_stock_qty !== undefined && custitem_br_commer_out_of_stock_qty !== null && _.isNumber(custitem_br_commer_out_of_stock_qty)) {
                                    isInStock = quantityavailable > custitem_br_commer_out_of_stock_qty;
                                } else if (custitem_br_wholes_out_of_stock_qty !== undefined && custitem_br_wholes_out_of_stock_qty !== null && _.isNumber(custitem_br_wholes_out_of_stock_qty)) {
                                    isInStock = quantityavailable > custitem_br_wholes_out_of_stock_qty;
                                }
                            }
                        } catch (ignoredError) {
                        }
                    }
                    return isInStock;
                }

                // Begin BZ39999
                try {
                    var CartSummaryView = require('Cart.Summary.View');
                    if (CartSummaryView) {
                        CartSummaryView.prototype.getContext = _.wrap(CartSummaryView.prototype.getContext, function (fn) {
                            var context = fn.apply(this, _.toArray(arguments).slice(1));
                            var lines = this.model.get('lines');
                            var hasOutOfStockItem = false;
                            for (var i = 0; i < lines.length; i++) {
                                var line = lines.at(i);
                                var item = line.get('item');
                                hasOutOfStockItem = !isInStock(item);
                                if (hasOutOfStockItem) {
                                    break;
                                }
                            }
                            if (hasOutOfStockItem) {
                                context.showActions = false;
                                setTimeout(function () {
                                    jQuery('.global-views-message-error').parent().remove();
                                    layout.showMessage({
                                        message: "Your shopping cart can currently not be ordered since one or more of the products in your cart are not available in the requested quantity. If you have any questions, please contact our customer service.",
                                        type: 'error'
                                    });
                                    if (window) {
                                        window.hasShowOutOfStockMessage = true;
                                    }
                                }, 1000);
                            } else {
                                setTimeout(function () {
                                    if (window && window.hasShowOutOfStockMessage) {
                                        window.hasShowOutOfStockMessage = false;
                                        jQuery('.global-views-message-error').parent().remove();
                                    }
                                }, 1000);
                            }
                            return context;
                        });
                    }
                } catch (ignoreError) {
                }

                try {
                    var OrderWizardModuleSubmitButton = require('OrderWizard.Module.SubmitButton');
                    if (OrderWizardModuleSubmitButton) {
                        OrderWizardModuleSubmitButton.prototype.getContext = _.wrap(OrderWizardModuleSubmitButton.prototype.getContext, function (fn) {
                            var context = fn.apply(this, _.toArray(arguments).slice(1));
                            var lines = this.model.get('lines');
                            var hasOutOfStockItem = false;
                            for (var i = 0; i < lines.length; i++) {
                                var line = lines.at(i);
                                var item = line.get('item');
                                hasOutOfStockItem = !isInStock(item);
                                if (hasOutOfStockItem) {
                                    break;
                                }
                            }
                            if (hasOutOfStockItem) {
                                context.hasOutOfStockItem = true;
                                setTimeout(function () {
                                    jQuery('.global-views-message-error').parent().remove();
                                    layout.showMessage({
                                        message: "Your shopping cart can currently not be ordered since one or more of the products in your cart are not available in the requested quantity. If you have any questions, please contact our customer service.",
                                        type: 'error'
                                    });
                                    if (window) {
                                        window.hasShowOutOfStockMessage2 = true;
                                    }
                                }, 1000);
                            } else {
                                setTimeout(function () {
                                    if (window && window.hasShowOutOfStockMessage2) {
                                        window.hasShowOutOfStockMessage2 = false;
                                        jQuery('.global-views-message-error').parent().remove();
                                    }
                                }, 1000);
                            }
                            return context;
                        });
                    }
                } catch (ignoreError) {
                }

                try {
                    var OrderWizardStep = require('OrderWizard.Step');
                    if (OrderWizardStep) {
                        OrderWizardStep.prototype.getContext = _.wrap(OrderWizardStep.prototype.getContext, function (fn) {
                            var context = fn.apply(this, _.toArray(arguments).slice(1));
                            var lines = this.wizard.model.get('lines');
                            var hasOutOfStockItem = false;
                            for (var i = 0; i < lines.length; i++) {
                                var line = lines.at(i);
                                var item = line.get('item');
                                hasOutOfStockItem = !isInStock(item);
                                if (hasOutOfStockItem) {
                                    break;
                                }
                            }
                            if (hasOutOfStockItem) {
                                context.showContinueButton = false;
                                setTimeout(function () {
                                    jQuery('.global-views-message-error').parent().remove();
                                    layout.showMessage({
                                        message: "Your shopping cart can currently not be ordered since one or more of the products in your cart are not available in the requested quantity. If you have any questions, please contact our customer service.",
                                        type: 'error'
                                    });
                                }, 1000);
                            }
                            return context;
                        });
                    }
                } catch (ignoreError) {
                }
                // End BZ39999

                ItemKeyMapping.getKeyMapping = _.wrap(ItemKeyMapping.getKeyMapping, function (fn) {
                    var mapping = fn.apply(this, _.toArray(arguments).slice(1));
                    mapping._isInStock = function (item) {
                        return isInStock(item);
                    }
                    mapping._isPurchasable = function (item) {
                        var isPurchasable = item.get('ispurchasable');
                        if (isPurchasable) {
                            isPurchasable = isInStock(item);
                        }
                        return isPurchasable !== undefined ? isPurchasable !== false : isPurchasable;
                    }
                    mapping._stock = function (item) {
                        var quantityavailable = item.get('quantityavailable');
                        if (quantityavailable !== undefined && quantityavailable > 0) {
                            if (!isInStock(item)) {
                                return 0;
                            }
                        }
                        return quantityavailable;
                    }
                    mapping._showOutOfStockMessage = function (item) {
                        var showoutofstockmessage = item.get('showoutofstockmessage');
                        if (!showoutofstockmessage) {
                            return !isInStock(item);
                        }
                        return showoutofstockmessage;
                    }
                    return mapping;
                });
                // Start to Remove Inventory Display extension component
                try {
                    var MessageRegularItemView = require('SuiteCommerce.InventoryDisplay.Message.RegularItem.View'),
                        MessageDropShipItemView = require('SuiteCommerce.InventoryDisplay.Message.DropShipItem.View'),
                        MessageSpecialOrderItemView = require('SuiteCommerce.InventoryDisplay.Message.SpecialOrderItem.View');
                    _.extend(MessageRegularItemView.ItemMessageView.prototype, {
                        isInStock: function () {
                            try {
                                var itemModel = new Backbone.Model(this.item);
                                if (!isInStock(itemModel)) {
                                    return false;
                                }
                            } catch (ignoredError) {
                            }
                            return this.getQuantityAvailable() > 0;
                        }
                    });
                    MessageRegularItemView.ItemMessageView.prototype.getStockMessage = _.wrap(MessageRegularItemView.ItemMessageView.prototype.getStockMessage, function (fn) {
                        var message = fn.apply(this, _.toArray(arguments).slice(1));
                        try {
                            if (!this.isInStock()) {
                                message = '';
                            }
                        } catch (ignoredError) {
                        }
                        return message;
                    });

                    _.extend(MessageDropShipItemView.DropShipItemMessageView.prototype, {
                        isInStock: function () {
                            try {
                                var itemModel = new Backbone.Model(this.item);
                                if (!isInStock(itemModel)) {
                                    return false;
                                }
                            } catch (ignoredError) {
                            }
                            return this.getQuantityAvailable() > 0;
                        }
                    });
                    MessageDropShipItemView.DropShipItemMessageView.prototype.getStockMessage = _.wrap(MessageDropShipItemView.DropShipItemMessageView.prototype.getStockMessage, function (fn) {
                        var message = fn.apply(this, _.toArray(arguments).slice(1));
                        try {
                            if (!this.isInStock()) {
                                message = '';
                            }
                        } catch (ignoredError) {
                        }
                        return message;
                    });

                    _.extend(MessageSpecialOrderItemView.SpecialOrderItemMessageView.prototype, {
                        isInStock: function () {
                            try {
                                var itemModel = new Backbone.Model(this.item);
                                if (!isInStock(itemModel)) {
                                    return false;
                                }
                            } catch (ignoredError) {
                            }
                            return this.getQuantityAvailable() > 0;
                        }
                    });
                    MessageSpecialOrderItemView.SpecialOrderItemMessageView.prototype.getStockMessage = _.wrap(MessageSpecialOrderItemView.SpecialOrderItemMessageView.prototype.getStockMessage, function (fn) {
                        var message = fn.apply(this, _.toArray(arguments).slice(1));
                        try {
                            if (!this.isInStock()) {
                                message = '';
                            }
                        } catch (ignoredError) {
                        }
                        return message;
                    });
                } catch (ignoredError) {

                }
                _.extend(QuickAddView.prototype, {
                    saveForm: function (e) {
                        e.preventDefault();
                        jQuery('.global-views-message-error').parent().remove();

                        Backbone.Validation.bind(this);

                        this.model.set(this.$('form').serializeObject());

                        const product = this.model.get('selectedProduct');

                        if (this.model.isValid(true) && product) {

                            if (!product.get('item').get('_isInStock')) {
                                layout.showMessage({
                                    message: "The selected item is Out Of Stock",
                                    type: 'error',
                                    selector: 'QuickAddView'
                                });
                                return;
                            }

                            product.set('quantity', parseInt(this.model.get('quantity'), 10));

                            const selected_line = new TransactionLineModel(product.toJSON());

                            selected_line.set('internalid', _.uniqueId('item_line'));
                            selected_line.set('item', product.getItem().clone());
                            selected_line.set('options', product.get('options').clone());

                            // if the item is a matrix we add the parent so when saving the item in a product list (request a quote case)
                            // we have the parent
                            if (product.get('item').get('_matrixChilds').length) {
                                selected_line.get('item').set('_matrixParent', product.get('item'));
                            }
                            selected_line.unset('selectedProduct');
                            selected_line.unset('quickaddSearch');

                            // @event {QuickAdd.View.SelectedLine.Properties} selectedLine
                            this.trigger(
                                'selectedLine',
                                // @class QuickAdd.View.SelectedLine.Properties
                                {
                                    // @property {Transaction.Line.Model} selectedLine
                                    selectedLine: selected_line
                                }
                            );
                            // @class QuickAdd.View

                            this.$('[name="quantity"]').val('');
                            this.$('[name="quantity"]').attr({
                                min: 1
                            });
                            this.$('[data-type="quick-add-reset"]').hide();
                            this.itemsSearcherComponent.cleanSearch();
                            this.itemsSearcherComponent.setFocus();
                        }
                    }
                });
            }
        };
    });
